export default __webpack_public_path__ + "information-circle.svg";